import ContentDialogAlert from "features/shared/components/contentDialog/ContentDialogAlert";
import IContentDialogService from "features/shared/components/contentDialog/IContentDialogService";
import { getDynamicConfig } from "infrastructure/configuration/configurationHelper";
import { useInjection } from "infrastructure/ioc/ioc.react";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import IAppState from "infrastructure/store/IAppState";
import React from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useIdleTimer } from "react-idle-timer";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { UserState } from "redux-oidc";

const PROMPT_BEFORE_IDLE_MS = 30 * 1000; // 30 seconds
const dynamicConfig = getDynamicConfig();

export const useIdleLogout = () => {
  // DI
  const dialogService = useInjection<IContentDialogService>(
    IocTypes.ContentDialogService
  );

  // translations
  const tLabels = useTranslation("shared/components").t;

  // router
  const history = useHistory();

  // store
  const userState = useSelector<IAppState, UserState>((state) => state.oidc);
  const isAuthenticated = !!userState.user && !userState.user.expired;

  // handlers
  const idleHandler = () => {
    if (isAuthenticated) {
      history.push("/logout");
    }
  };

  const resetIdleHandler = () => { 
    activate();
    dialogService.closeDialog();
  }

  const promptHandler = () => {
    dialogService.openDialog(
      tLabels("useIdleLogout.warningTitle"),
      renderWarningDialog,
      false
    );
  };

  // idle-timer
  const { reset, activate } = useIdleTimer({
    timeout: dynamicConfig.idleTimeout * 60 * 1000,
    onIdle: idleHandler,
    debounce: 500,
    crossTab: true,
    events: ["mousemove", "keydown", "click", "scroll", "touchstart"],
    promptBeforeIdle: PROMPT_BEFORE_IDLE_MS,
    onPrompt: promptHandler,
  });

  // sub-renders
  const renderWarningDialog = () => { 
    return <ContentDialogAlert
      alertObject={{
        alertType: "Info",
        message: tLabels("useIdleLogout.warningMessage"),
      }}
      actionBtns={() => <button className="btn btn-primary" onClick={resetIdleHandler}>{tLabels("useIdleLogout.keepLoggedIn")}</button>}
    />;
  }

  // side-effects
  useEffect(() => {
    if (isAuthenticated) {
      reset();
    }
  }, [isAuthenticated, reset]);
};
